import {
  DATASET_FOR_UI_CONFIG_REFRESH_ON_OPTIMIZE,
  DATASET_FOR_UI_CONFIG_REFRESH_ON_OPTIMIZE_WIP,
} from 'api/dataset/dataset.api'
import { OptJobType } from 'api/optJobs/optJobs.api'
import { useMemo } from 'react'

export function useDatasetRefreshToken(regularOptJobType: Extract<OptJobType, 'regular' | 'regular_wip'>) {
  return useMemo(() => {
    if (regularOptJobType === 'regular_wip') {
      return DATASET_FOR_UI_CONFIG_REFRESH_ON_OPTIMIZE_WIP
    }

    return DATASET_FOR_UI_CONFIG_REFRESH_ON_OPTIMIZE
  }, [regularOptJobType])
}
